export default __webpack_public_path__ + "static/media/spinner.b83e8684.svg";